// TODO(nuxt3): $ua даёт Vue-2-only модуль nuxt-user-agent. Middleware нигде
// не подключён; удалить вместе с nuxt-user-agent при апгрейде фронткита.
// eslint-disable-next-line consistent-return,func-names
export default function (context) {
  const isPc = context.$ua.deviceType() === 'pc';
  context.store.commit('device/setUserDevice', isPc);
}
